(function() {
  'use strict';

  // Higher values are a stronger condition, so we want to set fields to the highest value required by any rule
  var FIELD_STATE = {
    ENABLED : 0,
    READONLY : 1,
    DISABLED : 2
  };
  Object.freeze(FIELD_STATE); // should never change

  // Higher values are a stronger condition, so we want to set fields to the highest value required by any rule
  var VISIBILITY_STATE = {
    VISIBLE : 0,
    HIDDEN : 1
  };
  Object.freeze(VISIBILITY_STATE); // should never change

  window.FieldStateController = function(form_object, field_state_selector) {
    this._rules = form_object.getRules();
    this._formObject = form_object
    this._fieldStates = {};
    this._fieldStateSelector = field_state_selector;
  };

  /*
  * Call this method when a change has occurred in the form, to update fields according to the rules
  *
  * @param {jQuery} event_target
  */
  FieldStateController.prototype.update = function(event_target){
    if ( this._formObject ){
      this._formObject.update(event_target);
      this._updateStatesAccordingToRules();
      this._formObject.after_update(event_target);
    }
  };

  FieldStateController.prototype._updateStatesAccordingToRules = function(){
    this._determineCorrectFieldStates();
    Object.keys(this._fieldStates).forEach(
      this._disableOrHideFieldsAccordingToRules, this
    )
  }

  FieldStateController.prototype._determineCorrectFieldStates = function(){
    this._rules.forEach(this._applyRuleToListOfFields, this)
  }

  /*
  * @param {Object} rule
  * @param {string} rule.selector
  * @param {string} rule.field_type
  * @param {Boolean} rule.include_blank
  * @param {Boolean} rule.do_not_clear_when_disabled
  * @param {string} rule.field_state
  * @param {string} rule.visibility_state
  */
  FieldStateController.prototype._applyRuleToListOfFields = function(rule){
    this._addFieldToListOfFieldsIfNotAlreadyKnown(rule.selector, rule.field_type, rule.include_blank, rule.do_not_clear_when_disabled);
    if ( this._flagValueMeansRuleApplies(rule.flag, rule.value)){
      this._updateStateForField(rule.selector, rule.field_state, rule.disabled_text, rule.visibility_state)
    }
  }

  FieldStateController.prototype._flagValueMeansRuleApplies = function(flag, value){
    return this._formObject.getFlagValue(flag) === value
  }

  FieldStateController.prototype._addFieldToListOfFieldsIfNotAlreadyKnown = function(selector, field_type, include_blank, do_not_clear_when_disabled){
    if ( this._fieldStates[selector] === undefined){
      this._fieldStates[selector] = {
        field_type: field_type,
        include_blank: include_blank,
        do_not_clear_when_disabled: do_not_clear_when_disabled,
        field_state: null,
        visibility_state: null
      }
    }
  }

  FieldStateController.prototype._updateStateForField = function(selector, field_state, disabled_text, visibility_state){
    this._updateFieldStateForField(selector, field_state, disabled_text);
    this._updateVisibilityStateForField(selector, visibility_state);
  }

  FieldStateController.prototype._updateFieldStateForField = function(selector, field_state, disabled_text){
    var field_state_num = _findFieldStateNumber(field_state);
    if( field_state_num !== undefined && Math.max(field_state_num, this._fieldStates[selector].field_state) == field_state_num){
      this._fieldStates[selector].field_state = field_state_num;
      this._fieldStates[selector].disabled_text = disabled_text;
    }
  }

  FieldStateController.prototype._updateVisibilityStateForField = function(selector, visibility_state){
    var visibility_state_num = _findVisibilityStateNumber(visibility_state);
    if( visibility_state_num !== undefined ){
      this._fieldStates[selector].visibility_state = Math.max(visibility_state_num, this._fieldStates[selector].visibility_state);
    }
  }

  /*
  * @param {string} selector
  */
  FieldStateController.prototype._disableOrHideFieldsAccordingToRules = function(selector){
    var arg = this._fieldStates[selector]
    var $field = this._formObject.getField(selector);
    this._fieldStateSelector.applyFieldState($field, arg.field_type, arg.field_state, arg.include_blank, arg.disabled_text, arg.do_not_clear_when_disabled);
    _applyFieldVisibilty($field, arg.visibility_state);
  }

  function _findFieldStateNumber(state_string){
    return FIELD_STATE[state_string]
  }

  function _findVisibilityStateNumber(state_string){
    return VISIBILITY_STATE[state_string]
  }

  function _applyFieldVisibilty($field, visibility_state){
    if ( visibility_state === null ) { return; } // It doesn't make sense to set visibility_state for this selector
    switch(visibility_state){
      case 0:
         bootstrap.show($field);
        return;
      case 1:
        bootstrap.hide($field);
        return;
      default:
        throw('Unexpected visibility_state ' + visibility_state + ' in setFieldVisibilty')
    }
  };
})();
